import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { PhoneIcon } from '@rsos/assets/icons';
import ChatAvatar from '@rsos/components/capstone/Chat/ChatAvatar';
import AlertParticipant from './AlertParticipant';
import {
  Container,
  TitleBox,
  Title,
  Row,
  ParticipantInfo,
  ParticipantName,
  ParticipantDesc,
  PhoneNumber,
} from './ChatParticipants.styles';

/**
 * Displays a dropdown menu of current chat participants in the chat. For Alerts, there is
 * only a single chat participant between Central Station and RapidSOS Portal; However,
 * for 911 calls, there can be multiple chat participants between agencies in RapidSOS Portal.
 *
 * @param {object} alertChatParticipant - chat participant for alerts
 * @param {array} callChatParticipants - list of chat participants for 911 calls
 */
const ChatParticipants = ({ alertChatParticipants, callChatParticipants }) => {
  const { display_name: currentPSAPDisplayName } = useSelector(
    state => state.psaps.currentPSAP,
  );

  return (
    <Container>
      <TitleBox>
        <Title>Participants</Title>
      </TitleBox>
      {alertChatParticipants?.length > 0 &&
        alertChatParticipants.map(participant => (
          <AlertParticipant participant={participant} key={participant.id} />
        ))}
      {callChatParticipants &&
        callChatParticipants.length > 0 &&
        callChatParticipants.map(participant => (
          <Row key={participant.account_id}>
            <ChatAvatar name={participant.display_name} />
            <ParticipantInfo>
              <ParticipantName>{participant.display_name}</ParticipantName>
              {participant?.contact_phone && (
                <ParticipantDesc>
                  <PhoneIcon
                    width={10}
                    height={12}
                    viewboxWidth={11}
                    viewboxHeight={15}
                    color="secondaryText"
                  />
                  <PhoneNumber>{participant.contact_phone}</PhoneNumber>
                </ParticipantDesc>
              )}
            </ParticipantInfo>
          </Row>
        ))}
      <Row>
        <ChatAvatar name={currentPSAPDisplayName} />
        <ParticipantInfo>
          <ParticipantName>{currentPSAPDisplayName}</ParticipantName>
          <ParticipantDesc>Your Agency</ParticipantDesc>
        </ParticipantInfo>
      </Row>
    </Container>
  );
};

ChatParticipants.propTypes = {
  alertChatParticipants: PropTypes.array,
  callChatParticipants: PropTypes.arrayOf(
    PropTypes.shape({
      account_id: PropTypes.string,
      display_name: PropTypes.string,
      contact_phone: PropTypes.string,
    }),
  ),
};

export default ChatParticipants;
